import { spacings } from '../../../design/spacing/Spacing';

export const desktopHeaderContainerPadding = spacings['12px'];
export const headerHeight = '64px';
